/* eslint-disable */
import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import './Lead.css';
import AuthService from '../../Services/AuthService';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

class EditLead extends Component {

  state = {
    gender: '',
    school: '',
    suburb: '',
    guardianRelationship: '',
    open: false,
  };

  constructor() {

    super();

    this.Auth = new AuthService();

    this.state = {
      dateOfBirth: '',
      email: '',
      secondaryEmail: '',
      gender: '',
      guardianContact: '',
      guardianPhone: '',
      guardianRelationship: '',
      mobilePhone: '',
      phone: '',
      firstName: '',
      lastName: '',
      teacher1Email: '',
      teacher1Phone: '',
      teacher1Role: '',
      teacher1Contact: '',
      teacher2Email: '',
      teacher2Phone: '',
      teacher2Role: '',
      teacher2Contact: '',
      school: '',
      suburb: '',
      fireRedirect: false,
      lead: false,
      profile: {}
    }
  }
  componentWillMount() {
    this.state.lead = localStorage.getItem('hasLead');
    if (this.Auth.loggedIn() && this.state.lead == 0) {
      this.state.username = localStorage.getItem('username')
      this.props.history.replace(`/createlead`);
    } else if (!this.Auth.loggedIn()) {
      this.props.history.replace(`/signin`);
    } else if (this.Auth.loggedIn() && this.state.lead == 1) {
      this.props.history.replace(`/editlead`);
      this.state.profile = JSON.parse(localStorage.getItem('profile'));
      if (this.state.profile.name) {
        var array = this.state.profile.name.split(" ");
        this.state.firstName = array[0];
        this.state.lastName = array[1];
      }
      if (this.state.profile.phone) {
        this.state.phone = this.state.profile.phone;
      }
      if (this.state.profile.dateOfBirth) {
        this.state.dateOfBirth = this.state.profile.dateOfBirth;
      }
      if (this.state.profile.email) {
        this.state.email = this.state.profile.email;
      }
      if (this.state.profile.school.name) {
        this.state.school = this.state.profile.school.name;
      }
      if (this.state.profile.school.suburb) {
        this.state.suburb = this.state.profile.school.suburb;
      }
      if (this.state.profile.gender) {
        this.state.gender = this.state.profile.gender;
      }
      if (this.state.profile.secondaryEmail) {
        this.state.secondaryEmail = this.state.profile.secondaryEmail;
      }
      if (this.state.profile.mobilePhone) {
        this.state.mobilePhone = this.state.profile.mobilePhone;
      }
      if (this.state.profile.guardianContact) {
        this.state.guardianContact = this.state.profile.guardianContact;
      }
      if (this.state.profile.guardianPhone) {
        this.state.guardianPhone = this.state.profile.guardianPhone;
      }
      if (this.state.profile.guardianRelationship) {
        this.state.guardianRelationship = this.state.profile.guardianRelationship;
      }
      if (this.state.profile.teacher1Email) {
        this.state.teacher1Email = this.state.profile.teacher1Email;
      }
      if (this.state.profile.teacher1Phone) {
        this.state.teacher1Phone = this.state.profile.teacher1Phone;
      }
      if (this.state.profile.teacher1Role) {
        this.state.teacher1Role = this.state.profile.teacher1Role;
      }
      if (this.state.profile.teacher1Contact) {
        this.state.teacher1Contact = this.state.profile.teacher1Contact;
      }
      if (this.state.profile.teacher2Email) {
        this.state.teacher2Email = this.state.profile.teacher2Email;
      }
      if (this.state.profile.teacher2Phone) {
        this.state.teacher2Phone = this.state.profile.teacher2Phone;
      }
      if (this.state.profile.teacher2Role) {
        this.state.teacher2Role = this.state.profile.teacher2Role;
      }
      if (this.state.profile.teacher2Contact) {
        this.state.teacher2Contact = this.state.profile.teacher2Contact;
      }
    }
  }


  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOpen = () => {
    this.setState({
      open: true
    });
  };

  handleLead = async event => {
    event.preventDefault();
    this.setState({
      fireRedirect: true
    })
    console.log(leadData);

    const url = "https://connect-back-end.scottguo.com/api/user"

    const leadData = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      dateOfBirth: this.state.dateOfBirth,
      gender: this.state.gender,
      email: this.state.email,
      secondaryEmail: this.state.secondaryEmail,
      mobilePhone: this.state.mobilePhone,
      phone: this.state.phone,
      guardianContact: this.state.guardianContact,
      guardianPhone: this.state.guardianPhone,
      guardianRelationship: this.state.guardianRelationship,
      teacher1Email: this.state.teacher1Email,
      teacher1Phone: this.state.teacher1Phone,
      teacher1Role: this.state.teacher1Role,
      teacher1Contact: this.state.teacher1Contact,
      teacher2Email: this.state.teacher2Email,
      teacher2Phone: this.state.teacher2Phone,
      teacher2Role: this.state.teacher2Role,
      teacher2Contact: this.state.teacher2Contact,
      school: this.state.school,
      suburb: this.state.suburb
    }

    const headers = {
      'Content-type': 'application/json'
    }
    if (this.Auth.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.Auth.getToken()
    }
    fetch(url, {
        method: 'POST',
        body: JSON.stringify(leadData),
        headers
      })
      .then(res => res.json())
      .catch(error => console.error('Error:', error))
      .then(async response => {
        await this.Auth.hasLead()
          .then(res => {
            localStorage.setItem('profile', JSON.stringify(res.data.lead));
            localStorage.setItem('username', res.data.lead.name);
            window.location.reload();
            this.props.history.push('/profile');
          })
      });
  }


render(){

  const { from } = this.props.location.state || '/profile'
  const { fireRedirect } = this.state
  const { profile, dateOfBirth,email,secondaryEmail,gender,guardianContact,guardianPhone,guardianRelationship,
    mobilePhone,phone,firstName,lastName,teacher1Email,teacher1Phone,teacher1Role,teacher1Contact,
    teacher2Email,teacher2Phone,teacher2Role,teacher2Contact,school,suburb} = this.state;

return(
   <div style={{
            padding: '15px 50px 75px',
            width: '1200px',
            margin: 'auto',

          }}>
    <div>
        <MuiThemeProvider>
        <h2>EDIT PROFILE</h2>
          <form onSubmit={this.handleLead}>
            <fieldset>
                <legend>Student Details</legend>
            <div>
              <Grid container spacing={12}>
                <Grid item xs={3}>
                  <TextField
                    value={firstName}
                   hintText="Enter your First Name"
                   floatingLabelText="First Name"
                   margin="normal"
                   onChange = {(event,newValue) => this.setState({firstName:newValue})}
                   />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    value={lastName}
                     hintText="Enter your Password"
                     floatingLabelText="Last Name"
                     margin="normal"
                     onChange = {(event,newValue) => this.setState({lastName:newValue})}
                   />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    value={dateOfBirth}
                     hintText="Enter your Date of Birth"
                     floatingLabelText="Date of Birth"
                     id="date"
                     type="date"
                     margin="normal"
                     onChange = {(event,newValue) => this.setState({dateOfBirth:newValue})}
                   />
                </Grid>
 
                <Grid item xs={3}>
                <br/>
                <br/>
                <InputLabel htmlFor="gender-select" style={{ padding: '20px' }}>Select Gender</InputLabel>
                  <Select
                    open={this.state.open}
                    onClose={this.handleClose}
                    onOpen={this.handleOpen}
                    value={this.state.gender}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'gender',
                      id: 'gender-select',
                    }}
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Prefer Not to say">Prefer Not to say</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </Grid>

                <Grid item xs={3}>
                 <TextField
                 value={email}
                   hintText="Enter your Email"
                   floatingLabelText="Email"
                   onChange = {(event,newValue) => this.setState({email:newValue})}
                   />
                </Grid>
                
                <Grid item xs={3}>
                  <TextField
                  value={secondaryEmail}
                   hintText="Enter your Secondary Email"
                   floatingLabelText="Secondary Email"
                   onChange = {(event,newValue) => this.setState({secondaryEmail:newValue})}
                   />
                </Grid>
                
                <Grid item xs={3}>
                  <TextField
                  value={mobilePhone}
                   hintText="Enter your Mobile Phone"
                   floatingLabelText="Mobile Phone"
                   onChange = {(event,newValue) => this.setState({mobilePhone:newValue})}
                   />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                  value={phone}
                   hintText="Enter your Phone"
                   floatingLabelText="Phone"
                   onChange = {(event,newValue) => this.setState({phone:newValue})}
                   />
                </Grid>
              </Grid>
            </div>
            </fieldset>
            <br />

             <fieldset>
                <legend>Guardian Contact</legend>
            <div>
              <Grid container spacing={12}>
                <Grid item xs={3}>
                  <TextField
                  value={guardianContact}
                   hintText="Enter your Guardian Contact"
                   floatingLabelText="Guardian Contact"
                   margin="normal"
                   onChange = {(event,newValue) => this.setState({guardianContact:newValue})}
                   />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                  value={guardianPhone}
                     hintText="Enter your Guardian Phone"
                     floatingLabelText="Guardian Phone"
                     margin="normal"
                     onChange = {(event,newValue) => this.setState({guardianPhone:newValue})}
                   />
                </Grid>
                <Grid item xs={6}>
                <br/>
                <br/>
                <InputLabel htmlFor="guardian-select" style={{ padding: '20px' }}>Select Guardian Relationship</InputLabel>
                  <Select
                    open={this.state.open}
                    onClose={this.handleClose}
                    onOpen={this.handleOpen}
                    value={this.state.guardianRelationship}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'guardianRelationship',
                      id: 'guardian-select',
                    }}
                  >
                    <MenuItem value="Father">Father</MenuItem>
                    <MenuItem value="Mother">Mother</MenuItem>
                    <MenuItem value="Guardian">Guardian</MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </div>
            </fieldset>
            <br />

            <fieldset>
                <legend>Teacher Contact Details</legend>

            <div>
                  <Grid container spacing={12}>
                    
                    <Grid item xs={3}>
                      <TextField
                      value={teacher1Email}
                       hintText="Enter first Teacher Email"
                       floatingLabelText="First Teacher Email"
                       margin="normal"
                       onChange = {(event,newValue) => this.setState({teacher1Email:newValue})}
                       />
                    </Grid>

                    <Grid item xs={3}>
                      <TextField
                      value={teacher1Phone}
                         hintText="Enter First Teacher Phone"
                         floatingLabelText="First Teacher Phone"
                         margin="normal"
                         onChange = {(event,newValue) => this.setState({teacher1Phone:newValue})}
                       />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField
                        value={teacher1Role}
                         hintText="Enter First Teacher Role"
                         floatingLabelText="First Teacher Role"
                         onChange = {(event,newValue) => this.setState({teacher1Role:newValue})}
                         />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField
                        value={teacher1Contact}
                         hintText="Enter First Teacher Contact"
                         floatingLabelText="First Teacher Contact"
                         onChange = {(event,newValue) => this.setState({teacher1Contact:newValue})}
                         />
                    </Grid>

                  </Grid>

                  <Grid container spacing={12}>
                      <Grid item xs={3}>
                        <TextField
                        value={teacher2Email}
                         hintText="Enter Second Teacher Email"
                         floatingLabelText="Second Teacher Email"
                         margin="normal"
                         onChange = {(event,newValue) => this.setState({teacher2Email:newValue})}
                         />
                      </Grid>
                    
                      <Grid item xs={3}>
                        <TextField
                        value={teacher2Phone}
                           hintText="Enter Second Teacher Phone"
                           floatingLabelText="Second Teacher Phone"
                           margin="normal"
                           onChange = {(event,newValue) => this.setState({teacher2Phone:newValue})}
                         />
                      </Grid>
                      
                      <Grid item xs={3}>
                          <TextField
                          value={teacher2Role}
                           hintText="Enter Second Teacher Role"
                           floatingLabelText="Second Teacher Role"
                           onChange = {(event,newValue) => this.setState({teacher2Role:newValue})}
                           />
                      </Grid>
                      
                      <Grid item xs={3}>
                          <TextField
                          value={teacher2Contact}
                           hintText="Enter Second Teacher Contact"
                           floatingLabelText="Second Teacher Contact"
                           onChange = {(event,newValue) => this.setState({teacher2Contact:newValue})}
                           />
                      </Grid>
                      
                      <Grid item xs={3}>
                           <br/>
                        <br/>
                        <InputLabel htmlFor="school-select" style={{ padding: '20px' }}>Select Your School</InputLabel>
                          <Select
                            open={this.state.open}
                            onClose={this.handleClose}
                            onOpen={this.handleOpen}
                            value={this.state.school}
                            onChange={this.handleChange}
                            inputProps={{
                              name: 'school',
                              id: 'school-select',
                            }}
                          >
                          <MenuItem value="Smithton Primary School">Smithton Primary School</MenuItem>
                          <MenuItem value="A.G.B.U. Alexander Primary School">A.G.B.U. Alexander Primary School</MenuItem>
                          <MenuItem value="Abbotsford Primary School">Abbotsford Primary School</MenuItem>
                          <MenuItem value="Abbotsford Public School">Abbotsford Public School</MenuItem>
                          <MenuItem value="Abbotsleigh">Abbotsleigh</MenuItem>
                          <MenuItem value="Abercorn State School">Abercorn State School</MenuItem>
                          <MenuItem value="Aberdeen Public School">Aberdeen Public School</MenuItem>
                          <MenuItem value="Aberfeldie Primary School">Aberfeldie Primary School</MenuItem>
                          </Select>
                      </Grid>
                      <Grid item xs={3}>
                      <br/>
                        <br/>
                        <InputLabel htmlFor="suburb-select" style={{ padding: '20px' }}>Select Your Suburb</InputLabel>
                          <Select
                            open={this.state.open}
                            onClose={this.handleClose}
                            onOpen={this.handleOpen}
                            value={this.state.suburb}
                            onChange={this.handleChange}
                            inputProps={{
                              name: 'suburb',
                              id: 'suburb-select',
                            }}
                          >
                          <MenuItem value="SMITHTON">SMITHTON</MenuItem>
                          <MenuItem value="Abbotsford">Abbotsford</MenuItem>
                          <MenuItem value="Acacia Gardens">Acacia Gardens</MenuItem>
                          <MenuItem value="Abbotsleigh">Abbotsleigh</MenuItem>
                          </Select>
                      </Grid>
                  </Grid>
              
              <br/>
                <Button
                  type="submit"
                  style={{background: 'rgba(230, 70, 38, 0.95)'}}
                  variant="raised"
                  color="primary">
                  Update
                </Button>
              </div>
            </fieldset>
          </form>
         </MuiThemeProvider>
      </div>
  </div>

  )
  }

}

const style = {
 margin: 15,
};

export default EditLead;


// WEBPACK FOOTER //
// ./src/components/CreateLead/Edit.js